import { render, staticRenderFns } from "./mainSocialDetail.vue?vue&type=template&id=7e84d194&scoped=true&"
import script from "./mainSocialDetail.vue?vue&type=script&lang=js&"
export * from "./mainSocialDetail.vue?vue&type=script&lang=js&"
import style0 from "./mainSocialDetail.vue?vue&type=style&index=0&id=7e84d194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e84d194",
  null
  
)

export default component.exports